import * as Icon from 'react-feather';
import { Button, Divider, Flex } from 'antd';
import { useCallback } from 'react';
import { useFieldArray } from 'react-hook-form';
import styled from 'styled-components';
import { ExecutionPeriodsEditType } from '../schema';
import { PeriodSection } from './PeriodSection';
import React from 'react';

export function PeriodArray({
  sourceDataVersionId,
}: {
  sourceDataVersionId: number | null;
}) {
  const { fields, append, remove } = useFieldArray({
    name: 'periods',
    keyName: 'editId',
  });
  const count = fields.length;
  const appendRow = useCallback(() => {
    append(defaultPeriod(sourceDataVersionId));
  }, [append, sourceDataVersionId]);

  return (
    <PeriodWrapper>
      {fields.map((field, index) => {
        const isLast = index === count - 1;
        return (
          <React.Fragment key={field.editId}>
            <PeriodSection key={'ps-' + field.editId} index={index} />
            <Flex key={'btn-' + field.editId} gap="small">
              {isLast && (
                <StyledButton
                  id={`create-period-${index}`}
                  icon={<Icon.Plus size={18} />}
                  onClick={appendRow}
                />
              )}
              {count > 1 && (
                <StyledButton
                  id={`delete-period-${index}`}
                  icon={<Icon.Minus size={18} />}
                  onClick={() => remove(index)}
                />
              )}
            </Flex>
            {!isLast && <PeriodDivider key={`dr-${field.editId}`} />}
          </React.Fragment>
        );
      })}
    </PeriodWrapper>
  );
}

const StyledButton = styled(Button)`
  .ant-btn-icon {
    height: 18px;
  }
`;

const PeriodDivider = styled(Divider)`
  grid-column: span 2;
`;
const PeriodWrapper = styled.div`
  align-items: center;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 85px;
  padding: 20px 24px;
`;

export const generateId = (() => {
  let idInc = 0;
  return () => {
    return ['uid', ++idInc].join('-');
  };
})();

export function defaultPeriod(
  sourceDataVersionId: number | null
): ExecutionPeriodsEditType {
  return {
    id: null,
    editId: generateId(),
    existingPeriod: null,
    executionId: null,
    months: [],
    weekdays: [],
    days: [],
    hours: [],
    minutes: [],
    bankingDays: true,
    validPeriod: [null, null],
    periodCount: null,
    sourceDataVersionId,
  };
}
